<template>
  <div class="wholePageForIoTVRF">
    <div class="title">
        GREE GMOS+手机APP
    </div>
    <div class="imgContainer">
      <img :src="require('@/assets/img/手机APP.png')" width="80%">
    </div>
    <div class="desc">
      搭配GMVisual Master、IoT物联网关、多联机智控柜使用，实现手机端远程监控、能源管理、设备运维
    </div>
    <div class="btnContainer">
      <div class="downloadBtn" @click="downloadGMOSApp">
        <span>下载GREE GMOS+</span>
        <!-- SVG 图标：向右箭头 -->
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <line x1="5" y1="12" x2="19" y2="12"></line>
            <polyline points="12 5 19 12 12 19"></polyline>
        </svg>
      </div>
      <div class="downloadBtn" @click="openManual">
        <span>手机APP使用说明书</span> 
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <line x1="5" y1="12" x2="19" y2="12"></line>
            <polyline points="12 5 19 12 12 19"></polyline>
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "IoTVRF",
  methods: {
    downloadGMOSApp() {
      const url = 'http://gbms.gree.com:7003/gbms/GREE%20GMOS+.apk';
      const a = document.createElement('a');
      a.href = url;
      a.click();
      a.remove();
    },
    openManual() {
      window.open('/GREE%20GMOS%2B手机APP说明书20260722.pdf#toolbar=0&navpanes=0', '_blank');//不支持下载
      // window.open('/manual-viewer.html', '_blank');
    }
  }
}
</script>

<style scoped lang="less">
.wholePageForIoTVRF {
  // display: flex;
  padding-top: 20px;
  padding-left: 20px;
  padding-right: 20px;
  .title {
      font-size: 18px;
      font-weight: bold;
      color: #223A63;
      padding-bottom: 10px;
  }
  .desc {
    width:90%;
    font-size: 16px;
    color: #333;
    line-height: 24px;
    padding-top: 10px;
    text-align: left;
    margin-left: auto;
    margin-right: auto;
  }
  .btnContainer {
    margin: 20px 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;
    .downloadBtn {
      width: 80%;
      text-align: center;
      padding: 5px 0;
      border-radius: 2px;
      color: #f2f2f4;
      background-image: linear-gradient(to right, rgb(112, 68, 249), rgb(84, 106, 238));
      /* 新增箭头→的样式 */
      position: relative; /* 为伪元素定位做准备 */
      display: inline-flex; /* 建议改为 inline-flex 或 flex，方便垂直居中 */
      align-items: center; /* 垂直居中内容 */
      justify-content: center; /* 水平居中内容 */
      cursor: pointer; /* 鼠标悬停显示手型 */
      gap: 15px; 
    }
    .download-btn-secondary {
      display: inline-block;
      margin-top: 10px;
      padding: 8px 16px;
      background-color: #333;
      color: white;
      text-decoration: none;
      border-radius: 4px;
    }
  }
  
    /* 可选：鼠标悬停时稍微加深背景或改变图标颜色 */
    .downloadBtn:hover {
        opacity: 0.9;
    }
}
</style>